import request from '@/util/request'
import {
  JSON_CONFIG,
  getAPILangParam,
  FORM_CONFIG
} from '@/util/helper.js'

export function getAllHospital () {
  return request({
    url: '/misc/hospital',
    method: 'get'
  })
}

export function getHospitalByUser () {
  return request({
    url: '/misc/hospital',
    method: 'get'
  })
}

export function getServerStatus () {
  return request({
    url: '/',
    method: 'get',
    header: FORM_CONFIG
  })
}

export function getMessages (todoNext, notiNext) {
  return request({
    url: '/message',
    method: 'get',
    header: JSON_CONFIG,
    params: {
      todoPaging: todoNext,
      notiPaging: notiNext
    }
  })
}

export function getMessageDetail (messageId) {
  return request({
    url: `/message/${messageId}`,
    method: 'get',
    header: JSON_CONFIG
  })
}

export function sendNotification (patientId, type) {
  return request({
    url: `/patient/${patientId}/notification/${type}`,
    method: 'get',
    header: JSON_CONFIG
  })
}

export function getPatientList () {
  return request({
    url: '/message/patient',
    method: 'get',
    header: JSON_CONFIG
  })
}

export function getRehabData () {
  return request({
    url: '/misc/rehab',
    method: 'get',
    header: JSON_CONFIG,
    params: {
      lang: getAPILangParam()
    }
  })
}

export function postSatisfaction (requestBody) {
  return request({
    url: '/satisfaction',
    method: 'post',
    data: requestBody,
    header: JSON_CONFIG
  })
}

export function getCountryList () {
  return request({
    url: '/misc/country',
    method: 'get',
    header: JSON_CONFIG
  })
}



// WEBPACK FOOTER //
// ./src/api/misc.js